export default "__VITE_ASSET__KwaZoVNw__"